import { render, staticRenderFns } from "./shareReadingList.vue?vue&type=template&id=a89f2eda&scoped=true"
import script from "./shareReadingList.vue?vue&type=script&lang=js"
export * from "./shareReadingList.vue?vue&type=script&lang=js"
import style0 from "./shareReadingList.vue?vue&type=style&index=0&id=a89f2eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89f2eda",
  null
  
)

export default component.exports